module.exports = __webpack_public_path__ + "static/media/modal-close.5aa38a1c.svg";